module.exports = __webpack_public_path__ + "static/media/mail.2cfb0450.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/mail.svg
// module id = 91
// module chunks = 0